import { createContext } from 'react';

const subsistemaContext = createContext();

export default subsistemaContext;